import { DateRangePickerComponent } from "../components/form/DateRangePickerComponent";
import { DateRange } from "react-day-picker";
import { useEffect, useState } from "react";
import { Label } from "../components/form/Label";
import { Input } from "../components/form/Input";
import { AdvertsCard } from "../components/user_rentals/AdvertsCard";
import { NoneUserRented } from "./NoneUserRentedPage";
import CarRentalIcon from '@mui/icons-material/CarRental';
import { getUserProducts } from "../api/requests/product";
import { UserProductsListResponse } from "../api/requests/interfaces/Product";
import { useAppSelector } from "../store/hooks";
import { PagingParameters } from "../api/requests/interfaces/paging";
import { Helmet } from "react-helmet-async";
import {Spinner} from "../components/common/Spinner";
import {Pagination} from "@mui/material";

export const UserAdvertsList = () => {

    const [filterSearch, setFilterSearch] = useState(String);
    const [filterDate, setFilterDate] = useState<DateRange>();

    const [loading, setLoading] = useState<boolean>(true); // TODO: make skeleton for this page
    const [takeAdvertsCount, setTakeAdvertsCount] = useState(10);
    const [totalAdverts, setTotalAdverts] = useState(0);
    const [pageAdverts, setPageAdverts] = useState(0);

    const user = useAppSelector(state => state.auth.user);

    const [advertsList, setAdvertsList] = useState<UserProductsListResponse[]>(); // TODO: make skeleton for this page
    const [initialAdvertsLoad, setInitialAdvertsLoad] = useState<UserProductsListResponse[]>();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        getAdverts();
        //setAdvertsList(dummyData);
    }, [filterDate, filterSearch, takeAdvertsCount, pageAdverts]);

    const getAdverts = async () => {
        setLoading(true);
        setAdvertsList([]); // Without this line for some odd reason a random rental will stay in the list
        const res = await getUserProducts(user?.id!, { take: takeAdvertsCount,
            skip: pageAdverts * takeAdvertsCount, fromDate: filterDate?.from, toDate: filterDate?.to,
            searchString: filterSearch } as PagingParameters);
        setAdvertsList([...res.data]);
        setTotalAdverts(res.total);
        if (!initialAdvertsLoad?.length) {
            setInitialAdvertsLoad(res.data);
        }
        setLoading(false);
    }

    if (!initialAdvertsLoad?.length && !loading) {
        return (
            <NoneUserRented text={"Sa pole veel ühtegi kuulutust teinud."} buttonLink="/edit" buttonText="Loo kuulutus" icon={<CarRentalIcon className="text-primary" style={{ height: "100px", width: "100px" }} />} />
        )
    }

    return (
        (<div className="pt-[20px]">

            <Helmet>
                <title>Rentic - Minu Kuulutused</title>
                <meta name="description" content="Vaata üksikasju Sinu renti pandud esemete ja teenuste kohta." />
                <meta name="keywords" content="Rentic, rendiplatformi esemed, minu välja renditud, minu kuulutused, my rented items, rent an item, put to rent" />
                <meta property="og:title" content="Rentic - Minu Kuulutused" />
                <meta property="og:description" content="Vaata üksikasju Sinu renti pandud esemete ja teenuste kohta." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/my-adverts" />
            </Helmet>

            <h2 className="text-left pb-5">Minu kuulutused Renticus</h2>
            <div className="flex flex-row w-full gap-6 bg-blue-50 p-3 pl-5 pb-2 mb-8 rounded-xl flex-wrap">
                <div>
                    <Label value={"Nime otsing"} />
                    <Input placeHolder={"Otsi"} value={filterSearch} onChange={(value) => { setFilterSearch(value) }} />
                </div>
                {/* <div>
                    <Label value={"Staatus"} />
                    <Dropdown options={productStatusOptions} isMultiSelect={false} onSelect={(value) => {
                        const selectedStatus = productStatusOptions.find(option => option.value === value[0])?.value;
                        setFilterStatus(selectedStatus);

                    }} />
                </div> */}
                <div className="w-[280px]">
                    <Label value={"Kuulutus loodud"} />
                    <DateRangePickerComponent dateRangeChanged={(d) =>
                    { setFilterDate(d) }} validChanged={(v) => { }} disablePastDates={false} />
                </div>

            </div>
                {
                    loading ?
                        <div className="flex flex-row justify-center mt-2 w-full">
                            <Spinner />
                        </div>
                        :
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                            {advertsList!.map((item, index) => {
                                return (
                                    <AdvertsCard
                                        key={index}
                                        data={item}
                                    />
                                );

                            })}
                        </div>
                }
                {

                }
                <div className="flex justify-center mt-4">
                    <Pagination count={Math.floor(totalAdverts / takeAdvertsCount)} page={pageAdverts + 1}
                                onChange={(e, p) => setPageAdverts(p - 1)}/>
                </div>
        </div>
        )
    )

}